

export default function FooterComponent() {


    return (
        <footer className="footer">
            
                <div className="footerleft">No affiliation with the City of Chicago.</div>
                <div className="footerright">I created this page as a personal learning project—I am not going to give or sell any data to anyone else.</div>

        </footer>
    )
}